import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function KVKKAydinlatmaMetniPage() {
  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              KVKK Aydınlatma Metni
            </h1>

            <div className="space-y-8 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Veri Sorumlusu</h2>
                <div className="bg-gold-50 p-6 rounded-lg">
                  <p><strong>Emin Kuyumculuk</strong></p>
                  <p><strong>Adres:</strong> Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                  <p><strong>Telefon:</strong> 0531 603 68 91</p>
                  <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Kişisel Verilerin İşlenme Amaçları</h2>
                <p>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
                <ul className="list-disc list-inside ml-4 space-y-2 mt-4">
                  <li>Sipariş süreçlerinin yürütülmesi</li>
                  <li>Müşteri hizmetlerinin sunulması</li>
                  <li>Ürün ve hizmet kalitesinin artırılması</li>
                  <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                  <li>Pazarlama faaliyetlerinin yürütülmesi (izin dahilinde)</li>
                  <li>Müşteri memnuniyetinin ölçülmesi</li>
                  <li>İstatistiksel analiz ve raporlama</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">İşlenen Kişisel Veri Kategorileri</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Kimlik Bilgileri</h3>
                    <p className="text-sm">Ad, soyad, T.C. kimlik numarası, doğum tarihi</p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">İletişim Bilgileri</h3>
                    <p className="text-sm">Adres, telefon, e-posta adresi</p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Finansal Bilgiler</h3>
                    <p className="text-sm">Ödeme bilgileri, fatura adresi</p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">İşlem Bilgileri</h3>
                    <p className="text-sm">Sipariş geçmişi, tercihler, site kullanım bilgileri</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Kişisel Verilerin İşlenme Hukuki Sebebi</h2>
                <ul className="space-y-3">
                  <li>
                    <strong>Sözleşmenin kurulması ve ifası:</strong> Sipariş süreçleri ve teslimat
                  </li>
                  <li>
                    <strong>Yasal yükümlülük:</strong> Vergi mevzuatı, ticaret hukuku gereklilikleri
                  </li>
                  <li>
                    <strong>Açık rıza:</strong> Pazarlama iletişimi ve promosyonel aktiviteler
                  </li>
                  <li>
                    <strong>Meşru menfaat:</strong> Müşteri hizmetleri ve güvenlik
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Kişisel Verilerin Aktarıldığı Üçüncü Kişiler</h2>
                <p>Kişisel verileriniz aşağıdaki durumlar ve kişilerle sınırlı olarak paylaşılabilir:</p>
                <ul className="list-disc list-inside ml-4 space-y-2 mt-4">
                  <li>Kargo firmaları (teslimat için)</li>
                  <li>Ödeme kuruluşları (ödeme işlemleri için)</li>
                  <li>Yasal merciler (yasal yükümlülük halinde)</li>
                  <li>Muhasebe firması (finansal süreçler için)</li>
                  <li>Bilgi işlem hizmet sağlayıcıları (teknik destek için)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Kişisel Verilerin Saklanma Süresi</h2>
                <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-400">
                  <p>
                    Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca ve yasal 
                    saklama yükümlülükleri dikkate alınarak saklanır:
                  </p>
                  <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                    <li>Müşteri verileri: Müşteri ilişkisinin sona ermesinden sonra 10 yıl</li>
                    <li>Muhasebe kayıtları: Vergi mevzuatı uyarınca 10 yıl</li>
                    <li>Pazarlama verileri: İzin geri alınana kadar</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Veri Sahibi Hakları</h2>
                <p>KVKK Kanunu kapsamında sahip olduğunuz haklar:</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Bilgi Alma Hakkı</h3>
                    <p className="text-sm">Kişisel verilerinizin işlenip işlenmediğini öğrenme</p>
                  </div>
                  
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Erişim Hakkı</h3>
                    <p className="text-sm">İşlenen kişisel verilerinize erişim talep etme</p>
                  </div>
                  
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Düzeltme Hakkı</h3>
                    <p className="text-sm">Yanlış veya eksik verilerin düzeltilmesini isteme</p>
                  </div>
                  
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Silme Hakkı</h3>
                    <p className="text-sm">Koşulların oluşması halinde verilerin silinmesini isteme</p>
                  </div>
                  
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">İtiraz Hakkı</h3>
                    <p className="text-sm">Veri işlemeye itiraz etme ve durmasını isteme</p>
                  </div>
                  
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Taşınabilirlik Hakkı</h3>
                    <p className="text-sm">Verilerin yapılandırılmış formatta alınmasını isteme</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Başvuru Yöntemleri</h2>
                <p>
                  Yukarıdaki haklarınızı kullanmak için aşağıdaki kanallardan bize ulaşabilirsiniz:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg mt-4">
                  <div className="space-y-3">
                    <div>
                      <h4 className="font-medium text-gray-800">Yazılı Başvuru</h4>
                      <p className="text-sm text-gray-600">
                        Kimliğinizi tespit edici belgeler ile birlikte 
                        "Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA" adresine
                      </p>
                    </div>
                    
                    <div>
                      <h4 className="font-medium text-gray-800">E-posta</h4>
                      <p className="text-sm text-gray-600">
                        info@eminkuyumculuk.com.tr adresine güvenli elektronik imzalı e-posta ile
                      </p>
                    </div>
                    
                    <div>
                      <h4 className="font-medium text-gray-800">Telefon</h4>
                      <p className="text-sm text-gray-600">
                        0531 603 68 91 numaralı telefondan kimlik doğrulama sonrasında
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Veri Güvenliği</h2>
                <p>
                  Kişisel verilerinizin güvenliği için gerekli teknik ve idari tedbirleri alıyoruz. 
                  Verilerinizi yetkisiz erişim, kayıp, değişiklik ve ifşa risklerine karşı koruyoruz.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">İletişim</h2>
                <div className="bg-gold-50 p-6 rounded-lg">
                  <p className="text-gray-600 mb-4">
                    KVKK ile ilgili sorularınız için:
                  </p>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>Emin Kuyumculuk</strong></p>
                    <p><strong>Adres:</strong> Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                    <p><strong>Telefon:</strong> 0531 603 68 91</p>
                    <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
                  </div>
                </div>
              </section>

              <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-400">
                <p className="text-sm text-amber-800">
                  <strong>Son güncelleme:</strong> {new Date().toLocaleDateString('tr-TR')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}